module.exports = __webpack_public_path__ + "static/media/hint-textL.53ea740e.png";